import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 471px;
    margin: 0 auto;
    margin-top: 5px;
    margin-bottom: 40px;
    display: block;
    overflow: auto;
`;